<template>
  <div class="case-spisi kalendar-page">
    <div class="kalendar-left">
      <div class="opening-folder kalendar-wrapper">
        <div class="open-folder-line">
          <div class="open-folder-line-left">
            <div class="kalendar-page-dropdown">
              <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="computed_date" label="" append-icon="mdi-calendar" v-bind="attrs"
                    @click="menu = !menu" v-on="on" class="calendar-date-picker" color="#3326ae" readonly>
                  </v-text-field>
                </template>
                <v-date-picker locale="hr" color="#3326ae" type="month" v-model="chosen_date"
                  @change="menu = !menu; changeDate();"></v-date-picker>
              </v-menu>
            </div>
            <div class="shift-months">
              <div class="kalendar-prev" @click="prevMonth()">
                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13">
                  <g>
                    <g>
                      <path fill="none" stroke="#1e33f2" stroke-miterlimit="20" stroke-width="2"
                        d="M6.421 11.72v0L1.28 6.579v0L6.42 1.438v0" />
                    </g>
                  </g>
                </svg>
              </div>
              <div class="kalendar-next" @click="nextMonth()">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13">
                  <g>
                    <g>
                      <path fill="none" stroke="#1e33f2" stroke-miterlimit="20" stroke-width="2"
                        d="M.83 11.72v0l5.14-5.141v0L.83 1.438v0" />
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </div>
          <div class="open-folder-line-right">
            <div v-if="$route.name == 'CalendarGeneral'" style="margin-right: 0.5rem;" class="posta-dropdown">
              Prikaži:
              <select id="search-group multiple" v-model="select_source_type">
                <option v-for="(ev_type, key) in source_types" :key="key" :value="ev_type.id">{{ ev_type.naziv }}</option>

              </select>
              <!-- <input type="submit" value="Submit" /> -->
              <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg" />
            </div>
            <div class="posta-dropdown">
              Prikaži:
              <select id="search-group multiple" v-model="select_event_type">
                <option v-for="(ev_type, key) in filter_event_type" :key="key" :value="ev_type.id">{{ ev_type.naziv }}
                </option>

              </select>
              <!-- <input type="submit" value="Submit" /> -->
              <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg" />
            </div>
          </div>
        </div>
        <div class="kalendar">
          <div class="kalendar-daysofweek">
            <div class="kalendar-dayofweek">Ponedjeljak</div>
            <div class="kalendar-dayofweek">Utorak</div>
            <div class="kalendar-dayofweek">Srijeda</div>
            <div class="kalendar-dayofweek">Četvrtak</div>
            <div class="kalendar-dayofweek">Petak</div>
            <div class="kalendar-dayofweek">Subota</div>
            <div class="kalendar-dayofweek">Nedjelja</div>
          </div>
          <div class="kalendar-day-grid">
            <div v-if="fetching" class="center-spinner">
              <svg class="dot-spin" viewBox="0 0 50 50">
                <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
              </svg>
            </div>
            <div v-else v-for="(dan, key) in raspon_datuma" :key="key" :class="dan.classes"
              @click="updateClickedClass(key)" @dblclick="openCreateEvent(dan)">
              {{ dan.dan_enum }}
              <div class="today-events">

                <div v-for="(added_class, key) in dan.added_classes.slice(0, 6)" :key="key"
                  :class="'dot d-' + added_class"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Close spisi-left -->
    <div class="spisi-right kalendar-right">
      <div class="kalendar-info">
        <div style="display:flex">
          <div class="kalendar-info-text">{{ shown_date }}</div>
          <div class="shift-days">
            <div class="kalendar-day-prev"
              @click="kategorija_liste == 3 ? prevMonth() : kategorija_liste == 1 ? prevDay() : prevWeek()">
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13">
                <g>
                  <g>
                    <path fill="none" stroke="#606076" stroke-miterlimit="20" stroke-width="2"
                      d="M6.421 11.72v0L1.28 6.579v0L6.42 1.438v0" />
                  </g>
                </g>
              </svg>
            </div>
            <div class="kalendar-day-next"
              @click="kategorija_liste == 3 ? nextMonth() : kategorija_liste == 1 ? nextDay() : nextWeek()">
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13">
                <g>
                  <g>
                    <path fill="none" stroke="#606076" stroke-miterlimit="20" stroke-width="2"
                      d="M.83 11.72v0l5.14-5.141v0L.83 1.438v0" />
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </div>
        <div class="kalendar-info-wrapper">
          <div class="kalendar-info-dnevni" v-bind:class="[kategorija_liste == 1 ? 'active' : '']"
            @click="kategorija_liste = 1">
            Dnevni
          </div>
          <div class="kalendar-info-tjedni" v-bind:class="[kategorija_liste == 2 ? 'active' : '']"
            @click="kategorija_liste = 2">
            Tjedni
          </div>
          <div class="kalendar-info-mjesecni" v-bind:class="[kategorija_liste == 3 ? 'active' : '']"
            @click="kategorija_liste = 3">
            Mjesecni
          </div>
        </div>
      </div>
      <div class="events-pagination-wrapper">
        <EventCard v-for="(single_event, key) in finalni_arr_prikaza" v-bind:key="key" :single_event="single_event"
          :project_event="$route.name == 'KalendarProject' && single_event.event_type.uid == 1 ? true : false" />
        <div v-if="rasporedi_liste[kategorija_liste - 1].length == 0" class="case-kalendar-event-empty">Nemamo događaja
          u ovom vremenskom rasponu...</div>
      </div>
      <div v-if="rasporedi_liste[kategorija_liste - 1].length != 0 && all_pages.length > 1"
        class="cases-pagination-left">
        <div class="pagin-wrapp page-nav">
          <div class="page-nav-prev" v-if="!isFirstPage" @click="setPage(curr_page - 1)">
            <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
              xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
              <defs>
                <clipPath id="ClipPath1018">
                  <path
                    d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                    fill="#ffffff"></path>
                </clipPath>
              </defs>
              <g>
                <g>
                  <g>
                    <path class="sssdf"
                      d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                      fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                      stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                      clip-path='url("#ClipPath1018")'></path>
                  </g>
                  <g>
                    <g>
                      <path class="sssdr" d="M37.11694,40.02775v0l-4.09639,-4.09664v0l4.09639,-4.09638v0"
                        fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray=""
                        stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41"
                        stroke-miterlimit="20" stroke-width="2"></path>
                    </g>
                    <g>
                      <path d="M40.30245,40.02775v0l-4.09651,-4.09664v0l4.09651,-4.09638v0" fill-opacity="0"
                        fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                        stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20"
                        stroke-width="2"></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div class="page-nav-no">
            <div :class="{ 'curr-page': curr_page == 1 }" @click="setPage(1)">
              1
            </div>
          </div>
          <div class="page-nav-no" v-if="left_dots_visible">
            <div>
              ...
            </div>
          </div>
          <div class="page-nav-no" v-for="(str, key) in getLeftRightPages" :key="key" @click="setPage(str)">
            <div :class="{ 'curr-page': curr_page == str }">
              {{ str }}
            </div>
          </div>
          <div class="page-nav-no" v-if="right_dots_visible">
            <div>
              ...
            </div>
          </div>
          <div class="page-nav-no" v-if="all_pages.length > 1">
            <div :class="{ 'curr-page': curr_page == all_pages.length }" @click="setPage(all_pages.length)">
              {{ all_pages.length }}
            </div>
          </div>
          <div class="page-nav-next" v-if="!isLastPage" @click="setPage(curr_page + 1)">
            <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
              xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
              <defs>
                <clipPath id="ClipPath1043">
                  <path
                    d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                    fill="#ffffff"></path>
                </clipPath>
              </defs>
              <g>
                <g>
                  <g>
                    <path class="sssdf"
                      d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                      fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                      stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                      clip-path='url("#ClipPath1043")'></path>
                  </g>
                  <g>
                    <g>
                      >
                      <path class="sssdr" d="M33.88303,40.02775v0l4.09651,-4.09664v0l-4.09651,-4.09638v0"
                        fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray=""
                        stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41"
                        stroke-miterlimit="20" stroke-width="2"></path>
                    </g>
                    <g>
                      <path d="M30.69751,40.02775v0l4.09663,-4.09664v0l-4.09663,-4.09638v0" fill-opacity="0"
                        fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                        stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20"
                        stroke-width="2"></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <!-- <CalendarModal 
            v-if="popup_open"
              :se="chosen_event"
              @popup_close="closePopup()"
            >
            </CalendarModal> -->
  </div>
</template> 

<script>
import moment from "moment"
import auth from "@/services/auth"
import person from "@/apiCallers/person"
import ms_calendar from "@/apiCallers/calendarSharepoint"
// import CalendarCreateEdit from "@/components/caseComponents/CalendarCreateEdit.vue";
import CaseTab from "@/components/caseComponents/CaseTab.vue"
import CalendarModal from "@/components/calendarComponents/CalendarModal.vue"
import EventCard from "@/components/calendarComponents/EventCard.vue"
import permissioner from "@/services/permissioner.js"
import gsap from "gsap"


export default {
  components: { CaseTab, CalendarModal, EventCard },

  data: function () {
    return {
      selected_month: moment().month(),
      accessToken: "",
      //dnevni - idx0, tjedni - idx1, mjesecni - idx2,
      rasporedi_liste: [[], [], []],
      filter_event_type: [
        { naziv: "Svi događaji", id: 0 },
      ],
      select_event_type: 0,
      selected_year: moment().year(),
      raspon_datuma: [],
      current_day: moment().date(),
      chosen_date: moment().format("YYYY-MM"),
      shown_date: moment().format("DD.MM.YYYY."),
      menu: false,
      mjeseci: {
        0: "Siječanj",
        1: "Veljača",
        2: "Ožujak",
        3: "Travanj",
        4: "Svibanj",
        5: "Lipanj",
        6: "Srpanj",
        7: "Kolovoz",
        8: "Rujan",
        9: "Listopad",
        10: "Studeni",
        11: "Prosinac",
      },
      kategorija_liste: 1,
      curr_page: 1,
      br_redova: 4,
      all_pages: [],
      popup_open: false,
      chosen_event: null,
      finalni_arr_prikaza: [],
      is_clicked_on_calendar: true,
      fetching: true,
      source_types: [
        { id: 0, naziv: 'Svi izvori' },
        { id: 1, naziv: 'Osobno' },
        { id: 2, naziv: 'Predmeti' },
        { id: 3, naziv: 'Projekti' },
      ],
      select_source_type: 0,
      left_dots_visible: false,
      right_dots_visible: false,
    };
  },
  watch: {
    current_day: function () {
      this.$store.state.event_details.selected_day = this.current_day;
    },
    curr_page: function () {
      this.paginirajOdabrane();
    },
    select_event_type: async function () {
      this.$store.state.event_details.selected_type = this.select_event_type;
      await this.updateRasponDatuma();
      this.updateClickedClass(this.current_day);
      this.paginirajOdabrane();
    },
    select_source_type: async function () {
      await this.updateRasponDatuma();
      this.updateClickedClass(this.current_day);
      this.paginirajOdabrane();
    },
    kategorija_liste: function () {
      this.calculatePageNumber();
      this.paginirajOdabrane();
      switch (this.kategorija_liste) {
        case 1:
          this.raspon_datuma.forEach((dan) => {
            dan.classes = dan.classes.replaceAll("week", "");
            dan.classes = dan.classes.replaceAll("today", "");
          });
          this.selectDay(this.current_day);
          this.shown_date = moment(this.raspon_datuma[this.current_day].fullDate).format("DD.MM.YYYY")
          break;
        case 2:
          this.cleanClasses();
          var end_idx = 0;
          var start_idx = 0;
          var kvocijent = Math.floor(this.current_day / 7);
          start_idx = kvocijent * 7;
          end_idx = start_idx + 6;
          this.selectWeekRange(start_idx, end_idx);
          this.selectDay(this.current_day);
          break;
        case 3:
          this.cleanClasses();
          this.selectMonthRange();
          this.selectDay(this.current_day);
          break;
        default:
          break;
      }
    }
  },
  async created() {
    this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
    await this.updateRasponDatuma();
    let first_day = this.raspon_datuma.findIndex(obj => obj.dan_enum == 1);
    if (this.$store.state.event_details.selected_day != null && (this.$store.state.last_page_name == "EditProjectEvent" || this.$store.state.last_page_name == "EditPersonalEvent" || this.$store.state.last_page_name == "EditCaseEvent")) {
      this.current_day = this.$store.state.event_details.selected_day;
      this.select_event_type = this.$store.state.event_details.selected_type;
    }
    else {
      this.current_day = first_day + moment().date() - 1;
    }
    await ms_calendar.getEventType().then((resp) => {
      resp.data.map((ev) => this.filter_event_type.push({ naziv: ev.name, id: ev.uid }));
      this.filter_event_type.push({ naziv: "Riješeni", id: 6 })
    });
    this.updateClickedClass(this.current_day);
    this.paginirajOdabrane();
  },
  computed: {
    computed_date() {
      let date_arr = this.chosen_date.split("-");
      return this.mjeseci[parseInt(date_arr[1] - 1)] + ', ' + date_arr[0] + '.';
    },
    isFirstPage() {
      return this.curr_page == 1;
    },
    isLastPage() {
      return this.curr_page == this.all_pages[this.all_pages.length - 1];
    },
    getLeftRightPages() {
      // Init values
      let return_pages = []
      this.right_dots_visible = false;
      this.left_dots_visible = false;
      // Left of current page
      // 3 is the bottom value to make ... sense
      // LEFT LOOP
      let left_start = 2;
      let left_end = this.curr_page;
      if (this.curr_page == this.all_pages.length)
        left_end = this.curr_page - 1;
      if (this.curr_page > 3) {
        left_start = this.curr_page - 1;
        this.left_dots_visible = true;
      }
      for (let j = left_start; j <= left_end; j++) {
        return_pages.push(j);
      }
      // RIGHT LOOP
      let right_start = this.curr_page + 1;
      if (right_start < this.all_pages.length)
        return_pages.push(right_start);
      if (right_start < this.all_pages.length - 1)
        this.right_dots_visible = true;
      return return_pages
    },
  },
  methods: {
    is_permission_inside(wanted_permission) {
      return permissioner.check_case_permsision(wanted_permission)
    },
    openCreateEvent(dan) {
      console.log(dan);
      this.$store.state.chosen_date = dan.fullDate;
      if (this.$route.name == "Calendar") {
        if (this.is_permission_inside('case.calendar.create'))
          this.$router.push("kalendar/novi-dogadaj");
      } else {
          this.$router.push("/kalendar/novi-osobni-dogadaj")
      }
    },
    closePopup() {
      this.popup_open = false;
    },
    calculatePageNumber() {
      this.all_pages = [];
      var finalni_broj = this.rasporedi_liste[this.kategorija_liste - 1].length / this.br_redova;
      if (this.rasporedi_liste[this.kategorija_liste - 1].length % this.br_redova >= 1) {
        finalni_broj++;
      }
      for (var i = 1; i <= finalni_broj; i++) {
        this.all_pages.push(i);
      }
      if (this.all_pages.length != 0) {
        this.curr_page = 1;
      }
    },
    paginirajOdabrane() {
      let start_idx = 0 + this.br_redova * (this.curr_page - 1);
      let end_idx = this.br_redova * this.curr_page;

      this.finalni_arr_prikaza = this.rasporedi_liste[this.kategorija_liste - 1].slice(start_idx, end_idx);
    },
    setPage(pg) {
      this.curr_page = pg;
    },
    cleanClasses() {
      this.raspon_datuma.forEach((dan) => {
        dan.classes = dan.classes.replace("week", "");
        dan.classes = dan.classes.replace("today", "");
      });
    },

    //nedjelja je nula
    //ponedjeljak ima vrijednost 1
    updateClickedClass(list_idx) {
      //CLEAN values for day and week
      this.rasporedi_liste[0] = [];
      this.rasporedi_liste[1] = [];

      //Očisti sve klase
      this.cleanClasses();
      this.raspon_datuma[list_idx].classes =
        this.raspon_datuma[list_idx].classes + " today";
      moment.locale("hr");
      let clicked_day = parseInt(
        moment(this.raspon_datuma[list_idx].fullDate).day()
      );

      // console.log("clicked day " + clicked_day);
      var end_idx = 0;
      var start_idx = 0;
      var kvocijent = Math.floor(list_idx / 7);
      start_idx = kvocijent * 7;
      end_idx = start_idx + 6;
      this.getDayEventList(list_idx);
      this.getMonthEventList(start_idx, end_idx)

      this.current_day = list_idx;
      this.shown_date = moment(this.raspon_datuma[this.current_day].fullDate).format("DD.MM.YYYY")
      // console.log(this.is_clicked_on_calendar);
      if (this.is_clicked_on_calendar) {
        this.kategorija_liste = 1;
      }

      switch (this.kategorija_liste) {
        case 1:
          this.cleanClasses();
          this.selectDay(this.current_day);
          break;
        case 2:
          this.cleanClasses();
          this.selectWeekRange(start_idx, end_idx);
          this.selectDay(this.current_day);
          break;
        case 3:
          this.selectMonthRange();
          break;
        default:
          break;
      }
      this.calculatePageNumber();
      this.paginirajOdabrane();
    },
    async updateRasponDatuma() {
      this.fetching = true;
      this.finalni_arr_prikaza = [];
      (this.rasporedi_liste = [[], [], []]), (this.raspon_datuma = []);
      if (this.$route.name == "Calendar") {
        this.$store.state.paginacija.title = "Predmet";
        await ms_calendar
          .getCallendar(
            this.accessToken,
            this.selected_year,
            this.selected_month,
            this.$route.params.uid,
            this.select_event_type,
            'case'
          )
          .then((resp) => {
            this.raspon_datuma = resp.data.raspon_datuma;
            this.rasporedi_liste[2] = resp.data.filled_dates;
            this.fetching = false;
          });
      }
      else if (this.$route.name == "KalendarProject") {
        console.log("PROJ")
        this.$store.state.paginacija.title = "Projekti";
        await ms_calendar
          .getCallendar(
            this.accessToken,
            this.selected_year,
            this.selected_month,
            this.$route.params.uid,
            this.select_event_type,
            'project'
          )
          .then((resp) => {
            console.log(resp.data);
            this.raspon_datuma = resp.data.raspon_datuma;
            this.rasporedi_liste[2] = resp.data.filled_dates;
            this.fetching = false;
          });
      }
      else {
        this.$store.state.paginacija.title = "Upravljanje vremenom";
        let lawyer_id = await person.getSelf(this.accessToken);
        lawyer_id = lawyer_id.data.uid;

        await ms_calendar
          .getPersonCalendar(
            this.accessToken,
            this.selected_year,
            this.selected_month,
            lawyer_id,
            this.select_event_type,
            this.select_source_type
          )
          .then((resp) => {
            // console.log(resp.data);
            this.raspon_datuma = resp.data.raspon_datuma;
            this.rasporedi_liste[2] = resp.data.filled_dates;
            this.fetching = false;
          });
      }
      // console.log(this.raspon_datuma);
    },
    //update list of selected day events START
    selectMonthRange() {
      this.shown_date = this.computed_date;
      //Vrati index elementa u rasponu datuma s prvim danom u mjesecu
      var first_idx = this.raspon_datuma.findIndex(obj => obj.dan_enum == 1 || obj.dan_enum == 2);
      //postavi max vrijednost na vrijednost prvog dana u mjesecu
      var max_el_val = this.raspon_datuma[first_idx].dan_enum;
      //inicijaliziraj index zadnjeg dana u mjesecu na index prvog dana
      var last_idx = first_idx;
      //prolazi kroz raspon datuma dok se ne dodje do zadnjeg dana i spremi index zadnjeg dana
      for (let index = first_idx + 1; index < this.raspon_datuma.length; index++) {
        if (this.raspon_datuma[index].dan_enum > max_el_val) {
          //spremi vrijedost max elementa
          max_el_val = this.raspon_datuma[index].dan_enum
          //spremi trenutni najveći index
          last_idx = index;
        } else {
          break;
        }
      }
      for (let start_idx = first_idx; start_idx <= last_idx; start_idx++) {
        this.raspon_datuma[start_idx].classes =
          this.raspon_datuma[start_idx].classes + " week";
      }
    },

    selectWeekRange(start_idx, end_idx) {
      this.shown_date = moment(this.raspon_datuma[start_idx].fullDate).format("DD.MM.YYYY") + ' - ' + moment(this.raspon_datuma[end_idx].fullDate).format("DD.MM.YYYY")
      for (start_idx; start_idx <= end_idx; start_idx++) {
        this.raspon_datuma[start_idx].classes =
          this.raspon_datuma[start_idx].classes + " week";
      }
    },
    selectDay(day) {
      this.raspon_datuma[day].classes =
        this.raspon_datuma[day].classes + " today";
    },
    getDayEventList(day_idx) {
      this.rasporedi_liste[0] = this.raspon_datuma[day_idx].date_events;
    },

    getMonthEventList(strt_d, end_d) {
      for (var i = strt_d; i <= end_d; i++) {
        this.rasporedi_liste[1] = this.rasporedi_liste[1].concat(this.raspon_datuma[i].date_events);
      }
    },
    async changeDate() {
      let date_arr = this.chosen_date.split("-");
      this.selected_month = parseInt(date_arr[1] - 1);
      this.selected_year = parseInt(date_arr[0]);
      this.kategorija_liste = 2;
      this.kategorija_liste = 3;
      await this.updateRasponDatuma();
      this.is_clicked_on_calendar = false;
      this.updateClickedClass(this.current_day);
      this.is_clicked_on_calendar = true;
    },
    async changeDateDay() {
      let date_arr = this.chosen_date.split("-");
      this.selected_month = parseInt(date_arr[1] - 1);
      this.selected_year = parseInt(date_arr[0]);
      await this.updateRasponDatuma();
    },
    prevMonth() {
      this.chosen_date = moment(this.chosen_date).subtract(1, "M").format("YYYY-MM");
      this.changeDate();
    },
    nextMonth() {
      this.chosen_date = moment(this.chosen_date).add(1, "M").format("YYYY-MM");
      this.changeDate();
    },
    async prevDay() {
      if (this.current_day - 1 < 0) {
        let this_day = this.shown_date.split(".")[0];
        this.chosen_date = moment(this.chosen_date).subtract(1, "M").format("YYYY-MM");
        await this.changeDateDay();
        if (this_day != 1 && this_day != 2) {
          var last_day = this.raspon_datuma.find((day) => this_day - 1 == day.dan_enum);
          var last_idx = this.raspon_datuma.findIndex(obj => obj.dan_enum == 10);
          while (last_day.dan_enum > this.raspon_datuma[last_idx].dan_enum) {
            last_idx++;
          }
          this.current_day = last_idx;
        } else {
          this.current_day = this.raspon_datuma.length - 1;
        }

        this.kategorija_liste = 1;
        this.updateClickedClass(this.current_day);
      }
      else {
        this.updateClickedClass(this.current_day - 1)
      }
    },
    async nextDay() {
      console.log(this.raspon_datuma);
      if (this.current_day + 1 > this.raspon_datuma.length - 1) {
        this.chosen_date = moment(this.chosen_date).add(1, "M").format("YYYY-MM");
        await this.changeDateDay();
        let newDate = moment(this.shown_date, "DD.MM.YYYY").add(1, "days")
        var last_idx = this.raspon_datuma.findIndex(obj => obj.dan_enum == newDate.date());
        this.updateClickedClass(last_idx);
      }
      else {
        this.updateClickedClass(this.current_day + 1)
      }
    },
    async prevWeek() {
      var end_idx = 0;
      var start_idx = 0;
      if (this.current_day - 7 >= 0) {
        this.current_day -= 7;
        var kvocijent = Math.floor(this.current_day / 7);
        start_idx = kvocijent * 7;
        end_idx = start_idx + 6;
      } else {
        this.chosen_date = moment(this.chosen_date).subtract(1, "M").format("YYYY-MM");
        await this.changeDateDay();
        let found_less_10 = this.raspon_datuma.slice(28).find((dat) => dat.dan_enum < 10)
        if (found_less_10 != undefined) {
          var remaining_days = 14 - this.current_day - 1;
        } else {
          var remaining_days = 7 - this.current_day - 1;
        }
        this.current_day = this.raspon_datuma.length - 1 - remaining_days;
        var kvocijent = Math.floor(this.current_day / 7);
        start_idx = kvocijent * 7;
        end_idx = start_idx + 6;

      }
      this.is_clicked_on_calendar = false;
      this.updateClickedClass(this.current_day);
      this.is_clicked_on_calendar = true;
      this.selectWeekRange(start_idx, end_idx);
      this.selectDay(this.current_day);
    },
    async nextWeek() {
      var end_idx = 0;
      var start_idx = 0;
      if (this.current_day + 7 <= this.raspon_datuma.length - 1) {
        this.current_day += 7;
        var kvocijent = Math.floor(this.current_day / 7);
        start_idx = kvocijent * 7;
        end_idx = start_idx + 6;
      } else {
        this.chosen_date = moment(this.chosen_date).add(1, "M").format("YYYY-MM");
        await this.changeDateDay();
        let found_more_10 = this.raspon_datuma.slice(0, 7).find((dat) => dat.dan_enum > 20)
        if (found_more_10 != undefined) {
          var remaining_days = Math.abs(28 - this.current_day) + 7;
        } else {
          var remaining_days = Math.abs(28 - this.current_day);
        }
        this.current_day = remaining_days;
        var kvocijent = Math.floor(this.current_day / 7);
        start_idx = kvocijent * 7;
        end_idx = start_idx + 6;
      }

      this.is_clicked_on_calendar = false;
      this.updateClickedClass(this.current_day);
      this.is_clicked_on_calendar = true;
      this.selectWeekRange(start_idx, end_idx);
      this.selectDay(this.current_day);
    },
    // handleClickOutside(){
    //   setTimeout(() => {
    //     if (this.$store.state.event_details.popup_open) {
    //       gsap.to(".popup-wrapper",0.5,{opacity:0})
    //       gsap.to(".router-wrapper", 0.5, {
    //         filter: "none",
    //         opacity: 1,
    //       });
    //       // this.$emit('popup_close');
    //       setTimeout(() => {
    //         this.$store.state.event_details.popup_open = false;
    //       }, 500);
    //     }
    //   }, 500);
    // }
    //potrebni avatari na serveru
    // listaAvatara(ev) {
    //   var lista_avatara = [];
    //   var brojac = 1;
    //   ev.attendees.forEach((attendee) => {
    //     person
    //       .getUserPhoto(this.accessToken, attendee.emailAddress.address.trim())
    //       .then((response) => {
    //         var arrayBufferView = new Uint8Array(response.data);
    //         var blob = new Blob([arrayBufferView], { type: "image/jpeg" });
    //         var reader = new FileReader();
    //         reader.readAsDataURL(blob);
    //         lista_avatara.push(reader.result);
    //         reader.onloadend = function () {
    //           var base64data = reader.result;
    //           lista_avatara.push(base64data);
    //         //   console.log(lista_avatara);
    //         };
    //       });
    //   });

    //   return lista_avatara;
    // },
  },
  destroyed() {
    gsap.to(".router-wrapper", 0.5, {
      filter: "none",
      opacity: 1,
    });
    this.$store.state.event_details.popup_open = false;
  },
};

</script>

<style>
</style>